import React from 'react';
import classNames from 'classnames';
import { Radio, RadioGroup } from '@headlessui/react';

import { QuestionChoice } from 'types/Question';

import useLabelTranslation from 'hooks/useLabelTranslation';

import Icon from '../Icon';

interface SingleChoiceCardActionsProps {
  choices: QuestionChoice[];
  value: string;
  onChange: (value: string) => void;
}

const SingleChoiceCardActions: React.FC<SingleChoiceCardActionsProps> = ({ choices, value, onChange }) => {
  const { getLabelTranslation } = useLabelTranslation();

  return (
    <RadioGroup className="flex flex-col items-center gap-4" value={value} onChange={onChange}>
      {choices.map((choice) => {
        const checked = value === choice.id;
        return (
          <Radio
            key={choice.id}
            data-testid={`choice-${choice.id}`}
            value={choice.id}
            className={classNames(
              'group flex items-center justify-between w-full p-5 kiosk:p-10 bg-card-radio-bg rounded-card border-card-radio-border border-btn-primary-size cursor-pointer duration-500',
              {
                'has-hover:hover:border-btn-primary-hover-border': !checked,
                'has-hover:border-btn-primary-text': checked,
              },
            )}
          >
            <span className={classNames('text-left font-normal', checked && 'text-radio-secondary-active-text')}>
              {getLabelTranslation(choice.value)}
            </span>
            <div
              className={classNames(
                'group size-6 border-radio-size border-radio-secondary-border flex items-center justify-center shrink-0 duration-500 rounded-full',
                checked && 'bg-radio-secondary-active-bg !border-radio-secondary-active-border',
                !checked && 'group-hover:border-radio-secondary-hover-border',
              )}
            >
              {checked && <Icon className="fb-icon--check text-button-xs text-radio-secondary-active-dot" />}
            </div>
          </Radio>
        );
      })}
    </RadioGroup>
  );
};

export default SingleChoiceCardActions;
